export const gamesInfo = {
  set: 'GAMES_INFO_SET',
  add: 'GAMES_INFO_ADD',
  update: 'GAMES_INFO_UPDATE'
};

export const userInfo = {
  set: 'USER_INFO_SET',
  consumeEditor: 'USER_INFO_EDITOR',
  updateStorageUsage: 'USER_INFO_UPDATE_STORAGE'
};

export const userQuota = {
  set: 'USER_QUOTA_SET',
  showEditor: 'USER_QUOTA_EDITOR',
  selectCaseId: 'USER_QUOTA_SELECT_CASE_ID',
  addUseCase: 'ADD_USE_CASE',
  updateUseCase: 'UPDATE_USE_CASE'
};

export const uploadCases = {
  set: 'UPLOAD_CASES_SET',
  consumeEditor: 'UPLOAD_CASES_EDITOR',
  selectId: 'UPLOAD_CASES_SELECT_CASE_ID',
  add: 'UPLOAD_CASES_ADD_CASE',
  update: 'UPLOAD_CASES_UPDATE_CASE',
  remove: 'UPLOAD_CASES_REMOVE_CASE'
};
